import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "api/axiosInstance";
import { notify } from "../utils/notificationUtils";

export const listCustomers = createAsyncThunk(
    "customers/list",
    async (filters = '', thunkAPI) => {
        try {
            const queryString = Object.keys(filters)
                .map((key) => `${key}=${filters[key]}`)
                .join("&");

            const { data } = await api.get(`/customers?${queryString}`);

            return thunkAPI.fulfillWithValue(data);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const fetchCustomers = createAsyncThunk(
    "customers/sale",
    async (options, thunkAPI) => {
        try {
            const { data } = await api.get(`/customers/sale`);

            return thunkAPI.fulfillWithValue(data);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const createCustomer = createAsyncThunk(
    "customers/create",
    async (data, thunkAPI) => {
        try {
            const { data: response } = await api.post("/customers", data);
            return thunkAPI.fulfillWithValue(response);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateCustomer = createAsyncThunk(
    "customers/update",
    async (data, thunkAPI) => {
        try {
            const { data: response } = await api.put("/customers", data);
            return thunkAPI.fulfillWithValue(response);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteCustomer = createAsyncThunk(
    "customers/delete",
    async (idCustomer, thunkAPI) => {
        try {
            const { data: response } = await api.delete(`/customers/${idCustomer}`);
            return thunkAPI.fulfillWithValue(response);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);


const customersSlice = createSlice({
    name: "customers",
    initialState: {
        customers: [],
        saleCustomers: [],
        selectedCustomer: null
    },
    reducers: {
        setSelectedCustomer: (state, action) => {
            state.selectedCustomer = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(listCustomers.fulfilled, (state, action) => {
                state.customers = action.payload;
            })
            .addCase(fetchCustomers.fulfilled, (state, action) => {
                state.saleCustomers = action.payload;
            })
            .addCase(createCustomer.fulfilled, (state, action) => {
                notify('Cliente creado exitosamente', 'success')
                state.customers = [...state.customers, action.payload];
            })
            .addCase(updateCustomer.fulfilled, (state, action) => {
                notify('Cliente actualizado exitosamente', 'success')
                state.customers = state.customers.map(customer => {
                    if (customer.id === action.payload.id) {
                        return action.payload;
                    }
                    return customer;
                });
            })
            .addCase(deleteCustomer.fulfilled, (state, action) => {
                notify('Cliente eliminado exitosamente', 'success')
                state.customers = state.customers.filter(customer => customer.id !== action.payload.id);
            })
    }
});

export const {
    setSelectedCustomer
} = customersSlice.actions;

export default customersSlice.reducer;
